import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { LegendItem } from '@app/views/private/admin/dashboard-chart/dashboard-chart.component';

@Component({
  selector: 'app-chart-legend',
  templateUrl: './chart-legend.component.html',
  styleUrls: ['./chart-legend.component.scss']
})
export class ChartLegendComponent {

  @Output() submit = new EventEmitter<string>();
  @Output() hideChart = new EventEmitter<LegendItem>();

  @Input() legends: LegendItem[];
  @Input() buildingPDF: boolean;
  @Input() datasets;

  constructor(
  ) { }

  ngOnChanges(changes: SimpleChanges): void {

    if (this.datasets) {
      this.legends.forEach((item, index) => {
        if (this.datasets[index]) {
          item.count = this.datasets[index].data.length > 1 
            ? this.datasets[index].data.reduce((x, y) => x + y) 
            : this.datasets[index].data[0];
        }
      });
    }       
  }

  ngOnInit() {
    if (this.datasets) {
      this.legends.forEach((item, index) => {
        if (this.datasets[index]) {
          item.count = this.datasets[index].data.length > 1 
            ? this.datasets[index].data.reduce((x, y) => x + y) 
            : this.datasets[index].data[0];
        }
      });
    }
  }

  getStatus(legend : LegendItem) {
    if(legend.line){
      legend.hide = !legend.hide;
      this.hideChart.emit(legend);
    }else{
      this.submit.emit(legend.text);
    }
  }
}
